/**
 * BillingAccountAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatus } from './entityStatus';

export interface Merchant { 
    id?: string;
    readonly name?: string;
    readonly authId?: string;
    readonly billingEmail?: string;
    createdOn?: Date;
    updatedOn?: Date;
    terminatedOn?: Date;
    entityStatus?: EntityStatus;
}